import { useQuery } from '@tanstack/react-query';
import type {
  ActivityTrendRange,
  ApplicationsContract,
} from '@terra/shared-contracts-applications';
import { applicationsClient } from '@terra/shared-rest-clients-applications';
import {
  tenantAwareApiWrapper,
  withOrchestratorClient,
} from '../../clients/tester-client/portal/portal-http';

const getActivityTrend = ({
  applicationId,
  range,
}: {
  applicationId: string;
  range: ActivityTrendRange;
}) =>
  tenantAwareApiWrapper<
    typeof ApplicationsContract.getApplicationActivityTrend
  >({
    endpointFn: (headers) =>
      applicationsClient.getApplicationActivityTrend({
        params: { id: applicationId },
        query: { range },
        ...withOrchestratorClient(headers),
      }),
  });

export function useActivityTrend({
  applicationId,
  range,
}: {
  applicationId: string;
  range: ActivityTrendRange;
}) {
  return useQuery({
    queryKey: ['activity-trend', applicationId, range],
    queryFn: () => getActivityTrend({ applicationId, range }),
    enabled: applicationId.length > 0,
    staleTime: 60_000,
  });
}
